import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from "./live-tracking/components/main/Main"
import Vehicles from "./live-tracking/components/vehicle/Vehicles"
import AddressBook from "./live-tracking/components/addressbook/AddressBook"
import Jobs from "./live-tracking/components/jobs/Jobs"
import SpecificData from './live-tracking/components/specificData/SpecificData';
import PunctualityReport from './live-tracking/components/punctualityreport/PunctualityReport';
import MoreDetailedReport from './live-tracking/components/punctualityreport/MoreDetailedReport';
import WeekDetailReport from './live-tracking/components/punctualityreport/WeekDetailReport';


const CustomRoute = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Main />} />
        <Route exact path="/live-tracking/vehicles" element={<Vehicles />} />
        <Route exact path="/live-tracking/address-book" element={<AddressBook />} />
        <Route exact path="/live-tracking/jobs" element={<Jobs />} />
        <Route exact path="/:pnr" element={<SpecificData />} />
        <Route exact path="/live-tracking/punctuality-report" element={<PunctualityReport/>} />
        <Route exact path="/live-tracking/moredetailreport" element={<MoreDetailedReport/>} />
        <Route exact path="/live-tracking/weekdetailreport" element={<WeekDetailReport/>} />
      </Routes>
    </Router>
  );
};

export default CustomRoute;